import {
  IconButton,
  IconButtonProps,
  Button,
  ButtonProps,
} from "@mui/material";
import styled from "@mui/material/styles/styled";

import { Row } from "./Stack";

type GoogleButtonProps =
  | ({ asIcon?: false } & ButtonProps)
  | ({ asIcon: true } & IconButtonProps);

const GOOGLE_STYLES = {
  color: "#1f1f1f",
  border: "1px solid rgb(116,119,117)",
  borderRadius: "20px",
  height: "40px",
  fontFamily: "'Roboto', arial, sans-serif",
  fontSize: "14px",
  fontWeight: 500,
  letterSpacing: "0.25px",
  outline: "none",
  backgroundColor: "#fff",
  transition: "background-color .218s, border-color .218s, box-shadow .218s",
  padding: "12px",
  "&:hover": {
    backgroundColor: "#F5F5F5",
    boxShadow:
      "0 1px 2px 0 rgba(60, 64, 67, .30), 0 1px 3px 1px rgba(60, 64, 67, .15)",
  },
  "&:disabled": {
    backgroundColor: "#ffffff61",
    borderColor: "#1f1f1f1f",
  },
};

const StyledIconButton = styled(IconButton)({
  ...GOOGLE_STYLES,
  width: "40px",
  "& img": { width: "20px" },
});

const StyledButton = styled(Button)({
  ...GOOGLE_STYLES,
  "& img": { width: "20px", height: "20px" },
  justifyContent: "flex-start",
  whiteSpace: "nowrap",
  "& .MuiButton-startIcon": {
    marginRight: "12px",
    marginLeft: "0px",
    width: "20px",
    height: "20px",
  },
});

const GoogleButton = (props: GoogleButtonProps) => {
  if (props.asIcon) {
    return <StyledIconButton disableRipple {...props} />;
  }

  const { endIcon, ...buttonProps } = props;
  if (endIcon) {
    return (
      <Row variant="apart" sx={{ width: "100%" }} spacing={1}>
        <StyledButton {...buttonProps} />
        {endIcon}
      </Row>
    );
  }

  return <StyledButton {...buttonProps} />;
};

export default GoogleButton;
